import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func,
  onClick: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.string
}

function getAccessToken (user) {
  return user.getAuthResponse().id_token
}

function getUserProfile (user) {
  const profile = user.getBasicProfile()
  return {
    id: profile.getId(),
    name: profile.getName(),
    givenName: profile.getGivenName(),
    familyName: profile.getFamilyName(),
    email: profile.getEmail(),
    imageUrl: profile.getImageUrl()
  }
}

export default class GoogleSignIn extends React.Component {
  static propTypes = propTypes
  onLoginRef = (ref) => {
    if (!ref) return
    const { config } = this.props
    window.gapi.signin2.render('google-signin', {
      scope: config.scope,
      approval_prompt: config.approvalPrompt,
      prompt: config.prompt,
      'width': this.props.width || 240,
      'height': this.props.height || 50,
      'longtitle': true,
      'theme': this.props.theme || 'dark',
      'onsuccess': this.onSignIn,
      'onfailure': this.onFailure
    })
  }

  onSignIn = (user) => {
    const profile = getUserProfile(user)
    const accessToken = getAccessToken(user)
    this.props.onSuccess(profile, accessToken)
  }

  onFailure = (error) => {
    this.props.onFailure(error)
  }

  render () {
    return (
      <div>
        <meta name='google-signin-client_id' content={this.props.config.client_id} />
        <div onClick={this.props.onClick} ref={this.onLoginRef} id='google-signin' />
      </div>
    )
  }
}

GoogleSignIn.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func,
  onClick: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.string
}

export class SignInDiv extends React.Component {
  static propTypes = propTypes
  onRef = (ref) => {
    if (!ref) return
    const { config } = this.props
    window.gapi.auth2.getAuthInstance().attachClickHandler(ref, {
      scope: config.scope,
      approval_prompt: config.approvalPrompt,
      prompt: config.prompt,
      'width': this.props.width || 240,
      'height': this.props.height || 50,
      'longtitle': true,
      'theme': this.props.theme || 'dark',
      'onsuccess': this.onSignIn,
      'onfailure': this.onFailure
    })
  }

  onSignIn = (user) => {
    const profile = getUserProfile(user)
    const accessToken = getAccessToken(user)
    this.props.onSuccess(profile, accessToken)
  }

  onFailure = (error) => {
    this.props.onFailure(error)
  }

  render () {
    const { onSuccess, onFailure, config, width, height, theme, ...props } = this.props
    return (
      <React.Fragment>
        <meta name='google-signin-client_id' content={this.props.config.client_id} />
        <div {...props} ref={this.onRef} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Button.js